<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card
    class="d-flex flex-column justify-center"
    color="transparent"
    elevation="0"
    style="position:relative"
    tile
  >
    <apex-chart
      v-if="graphIsReady"
      :options="options"
      :series="series"
      :type="info.length < 16 ? 'bar' : 'area'"
      height="350"
      width="100%"
    />
  </v-card>
</template>
<script>

import dayjs from 'dayjs'
import Vue from 'vue'

export default {
  name: 'DaliyWinLostChart',
  props: {
    info: {}
  },
  data: function () {
    return {
      series: [],
      options: {},
      graphIsReady: false
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph: async function () {
      this.graphIsReady = false
      const dailyCost = () => {
        return this.info.map(it => {
          return {
            x: dayjs(it.date).format('MM-DD'),
            y: it.orderInfo.dailyCost
          }
        })
      }
      const dailySales = () => {
        return this.info.map(it => {
          return {
            x: dayjs(it.date).format('MM-DD'),
            y: it.orderInfo.totalTotalPrice
          }
        })
      }
      const dailyProfit = () => {
        return this.info.map(it => {
          return {
            x: dayjs(it.date).format('MM-DD'),
            y: it.orderInfo.dailyProfit
          }
        })
      }
      const zeroMark = dailyCost()[0].y
      const length = this.info.length
      this.series = [
        {
          name: this.$t('sales'),
          data: dailySales()
        },
        {
          name: this.$t('NetProfit'),
          data: dailyProfit()
        }
      ]

      this.options = {
        chart: {
          toolbar: {
            show: false
          }
        },
        fill: {
          colors: [
            '#3a3a3a',
            '#fbdc46',
            '#bababa'

          ]
        },
        yaxis: {
          show: this.info.length >= 16,
          labels: {
            show: this.info.length >= 16,
            formatter: Vue.filter('priceDisplay')
          }
        },
        annotations: {
          yaxis: [
            {
              y: zeroMark,
              borderColor: length > 1 ? '#999' : 'white',
              label: {
                text: length > 1 ? this.$t('DailysBreakEvenPoint') : '',
                style: {
                  background: '#bababa'
                }
              }
            }
          ]
        },
        grid: {
          show: false
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: Vue.filter('priceDisplay')
          }
        },
        xaxis: {
          crosshairs: {
            show: true,
            width: 1,
            position: 'back',
            opacity: 0.9,
            stroke: {
              color: '#b6b6b6',
              width: 0,
              dashArray: 0
            },
            fill: {
              type: 'solid',
              color: '#B1B9C4',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            },
            dropShadow: {
              enabled: false,
              top: 0,
              left: 0,
              blur: 1,
              opacity: 0.4
            }
          },
          axisBorder: {
            show: false
          },
          type: 'category',
          labels: {
            show: this.info.length < 16,
            hideOverlappingLabels: true,
            formatter: function (val) {
              if (length === 1) {
                return Vue.filter('priceDisplay')(val)
              } else {
                return dayjs(val, 'YYYY-MM-DD HH:mm:ss').format('DD.MM')
              }
            }
          },
          axisTicks: {
            show: false
          }
        }
      }
      this.graphIsReady = true
    }
  }
}
</script>

<style scoped>

</style>
